import { Reveal } from "@/lib/motion";

const chapters = [
  {
    num: "01",
    title: "Discover",
    body: "We embed with your team to understand objectives, brand codes and the story you need the floor to tell. Every build starts with strategy, not scenery.",
  },
  {
    num: "02",
    title: "Design",
    body: "Our in-house studio renders photoreal concepts and engineers them for real-world logistics — reconfigurable, reusable and on-budget.",
  },
  {
    num: "03",
    title: "Fabricate",
    body: "Owned production means quality control at every joint. Metal, millwork, print and AV integrated under one roof, one deadline.",
  },
  {
    num: "04",
    title: "Deploy",
    body: "Freight, install, on-site supervision and dismantle across 24 countries. You show up to a finished stand — we handle the rest.",
  },
];

export default function Manifesto() {
  return (
    <section id="process" className="border-y border-white/10 bg-[#080808]">
      <div className="mx-auto max-w-[1600px] px-6 py-28 md:px-10 md:py-40">
        <div className="mb-20 max-w-3xl">
          <div className="mb-5 flex items-center gap-3">
            <span className="h-px w-12 bg-[#FF3B30]" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/50">
              The process
            </span>
          </div>
          <Reveal>
            <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tighter md:text-6xl lg:text-7xl">
              Four moves.<br />Zero surprises.
            </h2>
          </Reveal>
        </div>

        <div className="divide-y divide-white/10">
          {chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.05}>
              <div className="group grid grid-cols-1 items-start gap-6 py-12 transition-colors md:grid-cols-12 md:gap-10">
                <span className="font-display text-6xl font-bold text-white/10 transition-colors duration-500 group-hover:text-[#FF3B30] md:col-span-3 md:text-8xl">
                  {c.num}
                </span>
                <h3 className="font-display text-3xl font-medium tracking-tight md:col-span-3 md:text-4xl">
                  {c.title}
                </h3>
                <p className="max-w-xl text-base font-light leading-relaxed text-white/60 md:col-span-6">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
